import { render, staticRenderFns } from "./Formulario2.vue?vue&type=template&id=6155a73c&scoped=true"
import script from "./Formulario2.vue?vue&type=script&lang=js"
export * from "./Formulario2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6155a73c",
  null
  
)

export default component.exports